import React from "react";
import "./List.scss";
import Card from "../Card/Card";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const List = ({ products, loading }) => {
    const selectedCurrency = useSelector((state) => state.currency.selectedCurrency);
    const rates = useSelector((state) => state.currency.rates);

    return (
        <div className="list">
            {loading
                ? <FormattedMessage id="loading" />
                : products?.map((item) => (
                    <Card
                        item={item}
                        key={item.id}
                        currency={selectedCurrency}

                        rates={rates}
                    />
                ))}
        </div>
    );
};

export default List;
